import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Adb2cService } from '@app/blocks/adb2c/services/adb2c/adb2c.service';
import { DocumentsListService } from '@app/documents/services/documents-list.service';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
   selector: 'app-documents-list',
   templateUrl: './documents-list.component.html',
   imports: [CommonModule, SpinnerComponent],
})
export class DocumentsListComponent implements OnInit {
   @Input() documentsListErrorMessage = '';
   @Input() documentsListNoDocumentsMessage = '';
   error: boolean = false;
   loading: boolean = false;
   public documents = new Array<any>([]);

   private destroy$ = new Subject<void>();
   private userSubscription?: Subscription;

   constructor(
      private adb2cService: Adb2cService,
      private documentsListService: DocumentsListService,
      private el: ElementRef
   ) {}

   ngOnInit() {
      this.loading = true;
      const cpt = this.el.nativeElement;
      this.documentsListErrorMessage = cpt.getAttribute('documentsListErrorMessage');
      this.documentsListNoDocumentsMessage = cpt.getAttribute('documentsListNoDocumentsMessage');

      this.adb2cService.getUser();
      this.userSubscription = this.adb2cService.activeUser
         .asObservable()
         .pipe(takeUntil(this.destroy$))
         .subscribe((user) => {
            console.log(user);
            const userId = user?.sub ?? user?.oid;
            if (user && userId) {
               this.documentsListService.getDocumentsList(userId).then(
                  (response: any) => {
                     if (response) {
                        this.documents = response;
                     }
                     this.loading = false;
                  },
                  (error) => {
                     if (error.status === 404) {
                        this.documents = [];
                     } else {
                        this.documents = [];
                     }
                     this.loading = false;
                  }
               );
            }
         });
   }
}
